import { useMutation } from '@tanstack/react-query';

import { userService } from 'services';
import { IAudienceShop } from 'types/api/audience';

export const useAssignMailCode = () => {
  return useMutation({
    mutationFn: async ({ orderNumber, id, shopId }: Pick<IAudienceShop, 'id' | 'orderNumber' | 'shopId'>) => {
      return await userService.getMailCode(orderNumber, id ?? null, shopId);
    },
  });
};
